interface AssigneeOption {
  accountId: string;
  displayName: string;
  kind?: 'jira' | 'portal';
}

/**
 * <option>s for an assignee <select>: people with a Jira account first, then
 * the rest of the team (assigned through the portal, notified on Slack).
 */
export function AssigneeOptions({ users }: { users: AssigneeOption[] | undefined }) {
  const jira = (users ?? []).filter((u) => u.kind !== 'portal');
  const team = (users ?? []).filter((u) => u.kind === 'portal');
  return (
    <>
      <option value="">Unassigned</option>
      {jira.length > 0 && (
        <optgroup label="Jira accounts">
          {jira.map((u) => <option key={u.accountId} value={u.accountId}>{u.displayName}</option>)}
        </optgroup>
      )}
      {team.length > 0 && (
        <optgroup label="Team — no Jira account (Slack updates)">
          {team.map((u) => <option key={u.accountId} value={u.accountId}>{u.displayName}</option>)}
        </optgroup>
      )}
    </>
  );
}
